export default __webpack_public_path__ + "static/media/pvilla6-4.fc5035a7.jpg";